import { useQuery } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom-v5-compat';
import { replace } from 'redux-first-history';

import config from '@/config';
import { logger } from '@/config/logger';

import { demoSignInWithOAuthResult } from '../../../services/oauth/signInWithOAuthResult';

export function useHandleDemoOAuthResult() {
    const location = useLocation();
    const dispatch = useDispatch();

    return useQuery({
        queryKey: ['handleDemoOAuthResult', location.hash],
        queryFn: async () => {
            try {
                await demoSignInWithOAuthResult(location.hash);

                return null;
            } catch (error) {
                logger.error(error);

                dispatch(replace(config.routes.home));
                throw error;
            }
        },
        retry: false,
        refetchOnWindowFocus: false,
        enabled: !!location.hash,
    });
}
